import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight } from 'lucide-react';
import { specials } from '../data/specials';

/** Homepage preview of the current promotions; full details live on /specials. */
export function SpecialsStrip() {
  return <section className="w-full py-14 px-4 border-y border-yellow-500/40" style={{
    backgroundColor: '#0b0b0b'
  }} aria-labelledby="specials-strip-heading" data-id="element-548" data-mp="2676hhoy964rk">
      <div className="max-w-7xl mx-auto" data-id="element-549" data-mp="2f8wagz7s9brg">
        <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-4 mb-8" data-id="element-550" data-mp="2f7v06wylctas">
          <div data-id="element-551" data-mp="2b69ohexsml26">
            <p className="text-sm font-black uppercase tracking-widest text-red-500" data-id="element-552" data-mp="2ozr78xinntr5">
              Limited Time Only
            </p>
            <h2 id="specials-strip-heading" className="mt-1 text-3xl sm:text-4xl md:text-5xl font-black uppercase text-white" data-id="element-553" data-mp="2k0eddstd9mf2">
              Current <span className="text-yellow-400" style={{
              color: "#FFE81A"
            }} data-id="element-554" data-mp="2yy6nu6k23kme">Specials</span>
            </h2>
          </div>
          <Link to="/specials" className="inline-flex items-center gap-2 text-yellow-400 font-black uppercase tracking-wider hover:text-yellow-300 transition-colors duration-150" style={{
          color: "#FFE81A"
        }} data-id="element-555" data-mp="1mzzhxl65tesw">
            View all specials
            <ArrowRight className="w-4 h-4" aria-hidden="true" data-id="element-556" data-mp="1vzmlacig8uol" />
          </Link>
        </div>

        <ul className="grid grid-cols-2 lg:grid-cols-4 gap-px bg-zinc-800 border border-zinc-800 rounded-xl overflow-hidden" data-id="element-557" data-mp="2100sxtg522m3">
          {specials.map(special => <li key={special.service} className="bg-black" data-id="element-558" data-mp="25x11cb0gnhgd">
              <Link to={special.path} className="flex flex-col h-full p-5 sm:p-6 hover:bg-zinc-900 transition-colors duration-150" data-id="element-559" data-mp="2awndsi8gsto4">
                <span className="text-4xl sm:text-5xl font-black text-yellow-400 leading-none" style={{
              color: "#FFE81A"
            }} data-id="element-560" data-mp="2fqrkd0dtizoo">
                  {special.amount}
                  <span className="ml-1 text-xl sm:text-2xl" data-id="element-561" data-mp="2oqegb6ns3dac">OFF</span>
                </span>
                <span className="mt-3 text-base sm:text-lg font-black uppercase text-white" data-id="element-562" data-mp="2tphkkovxpfh9">
                  {special.service}
                </span>
                {special.condition && <span className="mt-1 text-xs sm:text-sm text-gray-400" data-id="element-563" data-mp="ondiiudhmhbo">
                    {special.condition}
                  </span>}
              </Link>
            </li>)}
        </ul>
      </div>
    </section>;
}